import {useState} from "react";

import {AlertDetailsModal} from "@/pages/alerting/components/details/AlertDetailsModal.tsx";
import {IndexedGlobalAlertState} from "@/pages/checks/rta/components/AlertsList.tsx";

export const AlertListDetailsButton = ({gas}: {gas: IndexedGlobalAlertState}) => {
  const [showModal, setShowModal] = useState(false);

  if (gas.state_is_up) {
    return null;
  }

  if (!gas.state_is_up && !gas.state_has_changed) {
    return null;
  }

  return (
    <div className="mt-2">
      <button type="button" className="btn btn-sm btn-link" onClick={() => setShowModal(true)}>
        Alert Details
      </button>
      <AlertDetailsModal id={gas.id} show={showModal} hide={() => setShowModal(false)} />
    </div>
  );
};
